import { KatalComponent, register } from '../../shared/base';

@register('kat-table-head')
export class KatTableHead extends KatalComponent {
  static get observedAttributes() {
    return [];
  }

  constructor() {
    super(KatTableHead.observedAttributes);
  }

  connectedCallback() {
    super.connectedCallback();

    this.setAttribute('role', 'rowgroup');
  }
}
